import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').controller('LogoController', LogoController);

    function LogoController() {
        var vm = this;
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/auth/logo/logo.controller.ts